<div class="not-found__container">
	<div class="not-found__content">
		<h1>404</h1>
		<h2>Página não encontrada</h2>
		<p>
			O endereço que você tentou acessar não existe ou foi removido.<br />
			Verifique se o link está correto ou volte para a página inicial.
		</p>
	  <button class="btn btn-primary rounded-0" (click)="goToHome()">Voltar para o início</button>
	</div>
</div>
